// ResumableGuardian.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import debounce from 'lodash/debounce';

import { TranslationNamespace } from '../resource/translationNamespace.js';

const isClient = typeof window !== 'undefined';

export class ResumableGuardian extends React.Component {
  componentDidUpdate(prevProps) {
    const { resumableMessageItemIds } = this.props;
    if (
      resumableMessageItemIds &&
      resumableMessageItemIds !== prevProps.resumableMessageItemIds
    ) {
      isClient && this.handleListenerSubscribe();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleListenerSubscribe = debounce(() => {
    const { resumableMessageItemIds } = this.props;
    resumableMessageItemIds.length
      ? window.addEventListener('beforeunload', this.handleBeforeUnload)
      : window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }, 100);

  handleBeforeUnload = event => {
    const { t } = this.props;
    event.preventDefault();
    event.returnValue = t('alert_discarded', {
      ns: TranslationNamespace.POST,
    });
  };

  render() {
    return null;
  }
}
ResumableGuardian.propTypes = {
  resumableMessageItemIds: PropTypes.array,
  t: PropTypes.func.isRequired,
};

ResumableGuardian.defaultProps = {
  resumableMessageItemIds: [],
};

export default withTranslation()(ResumableGuardian);
